import getSettings from '../utils/settings';

const computeResultSocialCharges = (result, useNewRate = false) => {
    const rate = useNewRate
        ? getSettings('global.propertyIncomeSocialTaxRate')
        : getSettings('global.socialChargesRate');

    return Math.max(rate * result, 0);
};

export default computeResultSocialCharges;
